/**
 * @file: usePressTaskTimelineSectionHeader.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ReportNavParams } from '@euler/app/flows/report/ReportScreens';
import { TimelineSectionType } from '@euler/app/flows/task/functions/timeline/types';
import { useViewQuotation } from '@euler/app/flows/task/functions/useViewQuotation';
import { useViewReportWithTaskContext } from '@euler/app/flows/task/functions/useViewReportWithTaskContext';
import { TaskNavParams } from '@euler/app/flows/task/TaskFlow';
import { usePersistFn } from '@euler/utils/hooks';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';

export const usePressTaskTimelineSectionHeader = () => {
  const navigation = useNavigation<StackNavigationProp<ReportNavParams>>();
  const viewReport = useViewReportWithTaskContext();
  const onViewQuotation = useViewQuotation();

  return usePersistFn((section: TimelineSectionType) => {
    switch (section) {
      case 'order': {
        const nav = navigation as StackNavigationProp<TaskNavParams>;
        nav.navigate('taskDetail', {});
        break;
      }
      case 'quotation': {
        onViewQuotation();
        break;
      }
      case 'pre-inspection':
        viewReport('preInspectionReport', {});
        break;
      case 'inspection':
        viewReport('inspectionReport', {});
        break;
      case 'construction':
        viewReport('constructionReport', {});
        break;
      case 'delivery-check':
        viewReport('deliveryCheckReport', {});
        break;
      case 'sampling-check': {
        viewReport('samplingCheckReport', {});
        break;
      }
      default:
        break;
    }
  });
};
